import { Component, Input, OnInit } from '@angular/core';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { MaterialModule } from '../../../material/material.module';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-note-card-player',
    imports: [CommonModule, MaterialModule],
    templateUrl: './note-card-player.component.html',
    styleUrls: ['./note-card-player.component.css']
})
export class NoteCardPlayerComponent implements OnInit {
  @Input() Note: FlowItemModel;
  constructor() { }

  ngOnInit() {
  }

}
